module.exports = __webpack_public_path__ + "img/menus-black-new.138fd67f.svg";